import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import {
  CHECKOUT_REQUEST_SESSION_KEY,
  CURRENT_ENTRY_ID_SESSION_KEY,
  IS_CHECKOUT_CREATED_SESSION_KEY,
} from 'src/constants';
import { CheckoutRequest } from '~models';
import { AuthService, CheckoutV2Service, LoaderService, ZipYiService } from '~services';
import { ZipYiContext } from '~services/biocatch/zip-yi-context.enum';

@Component({
  selector: 'app-create-checkout-view',
  template: ``,
  standalone: false,
})
export class CreateCheckoutViewComponent implements OnInit, OnDestroy {
  constructor(
    private checkoutV2Service: CheckoutV2Service,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private zipYiService: ZipYiService,
    private authService: AuthService,
    private cookieService: CookieService,
  ) {}

  ngOnDestroy(): void {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    this.zipYiService.setContext(ZipYiContext.CreateCheckoutPage);
    const checkoutRequestFromSession = sessionStorage.getItem(CHECKOUT_REQUEST_SESSION_KEY);
    if (!checkoutRequestFromSession || this.isCheckoutCreated) {
      return this.navigateToCheckout();
    }
    const checkoutRequest = JSON.parse(checkoutRequestFromSession);
    await this.checkout(checkoutRequest);
  }

  async checkout(checkoutRequest: CheckoutRequest) {
    try {
      const response = await this.checkoutV2Service.createCheckout(checkoutRequest);
      const url = new URL(response.result.redirect_uri);
      url.searchParams.append('sso', 'true');
      this.isCheckoutCreated = true;
      this.setEntryId(this.productId);
      if (await this.authService.isAuthenticated()) {
        const cookieOptions = {
          domain: `.${window.location.hostname}`,
          path: '/',
          secure: true,
          expires: moment().add({ years: 1 }).toDate(),
        };

        this.cookieService.set('idp_cookie', this.authService.identityProvider, cookieOptions);
      }
      window.location.href = url.href;
    } catch (error) {
      const defaultStatus: string = "Uh oh, something's not right.";
      window.zbm?.reportError(error);
      this.router.navigate(['/error', defaultStatus]);
    }
  }

  private navigateToCheckout() {
    this.router.navigateByUrl(`/checkout/${this.productId}`);
  }

  private get productId() {
    return this.activatedRoute.snapshot.params.id;
  }

  private set isCheckoutCreated(value: boolean) {
    sessionStorage.setItem(IS_CHECKOUT_CREATED_SESSION_KEY, value.toString());
  }

  private get isCheckoutCreated() {
    return sessionStorage.getItem(IS_CHECKOUT_CREATED_SESSION_KEY) === 'true';
  }

  private setEntryId(entryId: string) {
    sessionStorage.setItem(CURRENT_ENTRY_ID_SESSION_KEY, entryId);
  }
}
